module.exports = __webpack_public_path__ + "img/driver-v3-bg.9e791baf.png";